import { CSSProperties } from 'react'

import Icon from '../Icon'

import styles from './customIcon.module.scss'

export type CustomIcons =
  | 'scg'
  | 'scg-simple'
  | 'cardKingdom'
  | 'tcg'
  | 'cardhorder'
  | 'cardmarket'
  | 'manapool'
  | 'tcgland'
  | 'cardtrader'
  | 'mtgo'
  | 'arena'
  | 'edhrec'
  | 'archidekt'

type Props = {
  name: CustomIcons
  className?: string
  style?: CSSProperties
}

const CustomIcon = ({ name, className, style }: Props) => {
  return <Icon className={`${name} ${styles.icon} ${className}`} style={style} />
}

export default CustomIcon
